module.exports = __webpack_public_path__ + "static/Review-ipad-img-1-24a2b060d8b6876c908f697bc283d7b1.jpeg";